import "../stylesheets/App.css";
import "../stylesheets/TempPassword.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "./subcomponents/Loader.js";
import PopupValidateEmail from "./subcomponents/PopupValidateEmail.js";

function ValidateEmail() {
  const [loading, setLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [validateCode, setValidateCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [user, setUser] = useState({});

  const navigate = useNavigate();

  const validate = async () => {
    setLoading(true);
    setErrorMsg("");

    const rawEmail = localStorage.getItem("user-email");
    if (!rawEmail) {
      setLoading(false);
      setErrorMsg("El enlace de validación no es válido");
      return;
    }

    const email = JSON.parse(rawEmail);
    const item = { email, validateCode };

    try {
      let resultUser = await fetch(
        process.env.REACT_APP_API_BASE_URL + "/users/getByEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );
      resultUser = await resultUser.json();

      if (resultUser.status !== 200) {
        setErrorMsg("El enlace de validación no es válido");
        return;
      }

      let result = await fetch(
        process.env.REACT_APP_API_BASE_URL + "/users/validateEmail",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );
      result = await result.json();

      if (result.status === 200) {
        setUser(result.data);
        setOpenPopup(true);
      } else {
        setErrorMsg(result.data);
      }
    } catch (e) {
      console.log(e);
      setErrorMsg("Ocurrió un error al validar el código.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <img
        className="temp-password-img"
        src={process.env.PUBLIC_URL + "/images/login/banner-login.png"}
        alt=""
      />

      <div className="temp-password-container section-70">
        <h1 className="temp-password-title">
          Por favor ingrese el código de validación que recibió en su correo
          electrónico.
          <br />
          ¡No olvides revisar en spam!
        </h1>

        <input
          className="inp"
          placeholder="Código de validación"
          id="validateCode"
          name="validateCode"
          onChange={(e) => setValidateCode(e.target.value)}
        />

        <span className="error-msg">{errorMsg}</span>

        <button type="submit" className="btn lightgreen-btn margin-bottom-10" onClick={validate}>
          Validar código
        </button>

        <button className="btn black-btn light-lime-btn" onClick={() => navigate("/login")}>
          Cancelar
        </button>
      </div>

      {loading ? <Loader /> : ""}
      {openPopup ? (
        <PopupValidateEmail
          user={user}
          title="Código válido!"
          description="¡Ya puedes comenzar a jugar!"
          setOpenPopup={setOpenPopup}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default ValidateEmail;
